
export const COMPANY_LIST = [
    { code: '154', plantId: 1, companyCode: 1, label: 'Fiat Automoveis S.A.', uf: 'MG' },
    { code: '167', plantId: 3, companyCode: 191, label: 'JEEP Pernambuco', uf: 'PE' },
    { code: '168', plantId: 1, companyCode: 10, label: 'FPT Fire - 010', uf: 'MG' },
    { code: '169', plantId: 1, companyCode: 12, label: 'FPT Mecânica - 012', uf: 'MG' },
    { code: '241', plantId: 4, companyCode: 3, label: 'Mopar - P&A', uf: 'MG' },
    { code: '243', plantId: 6, companyCode: 630, label: 'Porto Real', uf: 'RJ' }
];


export const JUSTIFICATION_LIST = [
    { code: 1, label: 'Absenteísmo' },
    { code: 2, label: 'Falta de espaço físico almoxarifado' },
    { code: 3, label: 'Falta de equipamento (Empilhadeira)' },
    { code: 4, label: 'Notas fiscais em Contingência/SEFAZ' },
    { code: 5, label: 'Acidente/Quebras veículo' },
    { code: 6, label: 'Queda de energia' },
    { code: 7, label: 'Indisponibilidade de embalagem' },
    { code: 8, label: 'Conferência vigilância' },
    { code: 9, label: 'Troca de turno / Refeição' },
    { code: 10, label: 'DEEM/Qualidade/SQP/BO' },
    { code: 11, label: 'Motorista não atende chamado para descarga/carga' },
    { code: 12, label: 'Condições Climáticas' },
    { code: 13, label: 'Prioridade de descarga em veículos com peças crítica' },
    { code: 14, label: 'Motorista Recusa o Carregamento​' },
    { code: 15, label: 'Material sem Digitação​' },
    { code: 16, label: 'Embalagem sem Cadastro Código e/ou Custo​​' },
    { code: 17, label: 'Aguardando Nota Fiscal​​' },
    { code: 18, label: 'Congestionamento Logístico - Pátio' },
    { code: 19, label: 'Sistemas Stellantis' },
];

export const STATUS_JANELA = [
    { status: "SJ", descricao: "SEM JANELA" },
    { status: "NPRE", descricao: "NÃO PREVISTA" },
    { status: "NP", descricao: "NÃO PREVISTA" },
    { status: "AD", descricao: "ADIANTADA" },
    { status: "AT", descricao: "ATRASADA" }
]

export const MVM_STATUS = [
    { code: '', label: 'Todos' },
    { code: 'CAN', label: 'Cancelado' },
    { code: 'RAS', label: 'Rascunho' },
    { code: 'PEM', label: 'Pendente de Entrada do MVM' },
    { code: 'PID', label: 'Pendente de Iniciar Descarga de Material' },
    { code: 'PFD', label: 'Pendente de Finalizar Descarga de Material' },
    { code: 'PIC', label: 'Pendente de Iniciar Carga de Vasilhame' },
    { code: 'PFC', label: 'Pendente de Finalizar Carga de Vasilhame' },
    { code: 'POT', label: 'Pendente de Ordem de Transporte' },
    { code: 'PEC', label: 'Pendente de Encerramento Contábil' },
    { code: 'PFA', label: 'Pendente de Faturamento' },
    { code: 'PSM', label: 'Pendente de Saída do MVM' },
    { code: 'CON', label: 'Concluído' },
]

export const MVC_STATUS = [
    { code: '', label: 'Todos' },
    { code: 'RAS', label: 'Rascunho' },
    { code: 'EMT', label: 'Emitido' },
    { code: 'REC', label: 'Recebido' },
    { code: 'CAN', label: 'Cancelado' }
]

export const OUTGOING_INVOICE_REQUEST_STATUS = [
    { code: '', label: 'Todos' },
    { code: 'SUB', label: 'Emitido' },
    { code: 'SNT', label: 'Enviado ao SAP' },
    { code: 'SSE', label: 'Erro ao enviar mensagem ao SAP' },
    { code: 'REN', label: 'Retorno de NF de Entrada do SAP' },
    { code: 'RON', label: 'Retorno de NF de Saída do SAP' },
    { code: 'RRS', label: 'Retorno de Requisição do SAP' },
]

export const MVM_JIS_STATUS = [
    { code: 'J', label: 'JIS' },
    { code: 'K', label: 'Não JIS' },
    { code: 'E', label: 'E-Kamban' },
    { code: 'I', label: 'Interno' },
    { code: 'C', label: 'Carreta' },
    { code: 'F', label: 'Funilaria' },
]

export const COMPANIES_WITH_FCM_RACKS = [154, 167];

export const MVM_RACKLOAD_TYPE = [
    { code: '9999', label: 'Ordem de Transporte (Emb. Standard)' },
    { code: '6920', label: 'Remessa Específica - 6920' },
    { code: '5920', label: 'Remessa Específica PE - 5920' },
    { code: '6921', label: 'Devolução Específica - 6921' },
    { code: '5921', label: 'Devolução Especifica PE - 5921' },
]

export const OUTGOING_MATERIAL_INVOICE_TYPE = [
    { code: 'MVN', label: 'Venda' },
    { code: 'MTF', label: 'Transferência' },
    { code: 'MSM', label: 'Simples Remessa' },
]

export const MVM_RACKLOAD_TYPE_FIASA = [
    { code: '9999', label: 'FCM' },
    { code: '6920', label: 'Remessa' },
    { code: '5920', label: 'Remessa' },
    { code: '6921', label: 'Devolução' },
    { code: '5921', label: 'Devolução' },
]

export const SELECT_ONLY_ERROR = [
    { code: '', label: 'Todos' },
    { code: '1', label: 'Apenas com Erro' },
    { code: '2', label: 'Apenas Sem Resposta' },
    { code: '3', label: 'Com Erro e Sem Resposta' },
    { code: '4', label: 'Não Enviado' },
    { code: '0', label: 'Apenas sem Erro' }
]

export const MDFE_UNIDADE_MEDIDA = [
    { code: '01', label: 'KG' },
    { code: '02', label: 'TON' },
]
export const MDFE_STATUS = [
    { code: 'AUT', label: 'Autorizado' },
    { code: 'CAN', label: 'Cancelado' },
    { code: 'ERREFO', label: 'Validado no E-Forms com Erro' },
    { code: 'ERRSEE', label: 'Evento Rejeitado' },
    { code: 'ERRSEF', label: 'MDF-e/Evento Rejeitado' },
    { code: 'ERRSEM', label: 'MDF-e Rejeitado' },
    { code: 'PENCAN', label: 'Pendente Envio de Cancelamento' },
    { code: 'PENENV', label: 'Pendente de Envio' },
    { code: 'PENPRT', label: 'Pendente Validação E-Forms' },
    { code: 'PENREC', label: 'Pendente Envio de Recebimento' },
    { code: 'PENRET', label: 'Pendente Retorno Sefaz' },
    { code: 'PENREV', label: 'Pendente de Revisão' },
    { code: 'PENVAL', label: 'Pendente de Validação' },
    { code: 'RAS', label: 'Rascunho' },
    { code: 'RECEB', label: 'Recebido' }
]

export const PERIMETER_DAFAULT = [
    { code: 'PADRAO', label: 'PADRÃO' }
]

export const ORIGINS = [
    { code: 'AER', label: 'Aéreo' },
    { code: 'MAR', label: 'Marítimo' },
    { code: 'ROD', label: 'Rodoviário' }
]

export const POOL_POINT_LIST = [
    { code: '00803', label: '(00803) - AEROPORTO DE GUARULHOS (GRU)' },
    { code: '00805', label: '(00805) - PORTO TECON SUAPE' },
    { code: '00806', label: '(00806) - AEROPORTO INTERNACIONAL DE RECIFE' },
    { code: '00808', label: '(00808) - SANTOS BTP PORT (PORTO DE SANTOS)' },
    { code: '00809', label: '(00809) - MULTIRIO PORT (PORTO DE RIO DE JANEIRO)' },
    { code: '00814', label: '(00814) - AEROPORTO INTERNACIONAL DE VIRACOPOS' },
    { code: '00815', label: '(00815) - BH AIRPORT - CONFINS (AEROPORTO DE CONFINS)' },
]

export const FIASA_PLANT_ID = 1;
export const FIAPE_PLANT_ID = 3;
export const MOPAR_PLANT_ID = 4;
export const PORTO_REAL_PLANT_ID = 6;